import React, { useMemo } from "react";
import styles from "./Flex.module.css";

interface FlexProps {
  className?: string;
  children?: React.ReactNode;
  direction?: "row" | "column" | "row-reverse" | "column-reverse";
  justify?: "start" | "end" | "center" | "space-between" | "space-around" | "space-evenly";
  align?: "start" | "end" | "center" | "stretch" | "baseline";
  wrap?: "nowrap" | "wrap" | "wrap-reverse";
  gap?: number;
  basis?: string;
  grow?: number | "inherit" | "initial" | "unset" | "revert" | "revert-layer";
  shrink?: number | "inherit" | "initial" | "unset" | "revert" | "revert-layer";
  style?: object;
}

export default function Flex({
  className,
  children,
  gap,
  direction,
  justify,
  align,
  wrap,
  basis,
  grow,
  shrink,
  style,
  ...rest
}: FlexProps) {
  const styleClasses = useMemo(
    () =>
      Object.entries({ direction, justify, align, wrap }).reduce((acc, [key, value]) => {
        if (value) {
          return acc + ` ${styles[`${key}-${value}`]}`;
        }
        return acc;
      }, className ? `${className} ${styles.flex}` : `${styles.flex}`),
    [className, direction, justify, align, wrap]
  );
  const inlineStyles = useMemo(
    () =>
      Object.entries({ basis, grow, shrink }).reduce(
        (acc, [key, value]) => {
          if (value) {
            return { ...acc, ["flex" + key.slice(0, 1).toUpperCase() + key.slice(1)]: value };
          }
          return acc;
        },
        gap ? { gap: `${gap * 0.25}rem` } : {}
      ),
    [basis, grow, shrink, gap]
  );

  const combinedStyles = {...inlineStyles, ...style };

  return (
    <div className={styleClasses} style={combinedStyles} {...rest}>
      {children}
    </div>
  );
}
